import { createFileRoute } from "@tanstack/react-router";
import { CrudManager } from "@/components/admin/CrudManager";

export const Route = createFileRoute("/admin/propostas")({ component: Page });

function Page() {
  return (
    <CrudManager
      table="proposals"
      label="Propostas"
      slugSource="title"
      fields={[
        { name: "title", label: "Título", type: "text", required: true },
        { name: "slug", label: "Slug", type: "slug", required: true },
        { name: "summary", label: "Resumo", type: "textarea" },
        { name: "description", label: "Descrição", type: "richtext" },
        { name: "problem", label: "Problema", type: "richtext" },
        { name: "solution", label: "Solução", type: "richtext" },
        { name: "how_it_works", label: "Como funciona", type: "richtext" },
        { name: "expected_impact", label: "Impacto esperado", type: "richtext" },
        { name: "audience", label: "Público-alvo", type: "text" },
        { name: "icon", label: "Ícone (nome lucide)", type: "text" },
        { name: "image_url", label: "Imagem", type: "image" },
        { name: "image_alt", label: "Texto alternativo da imagem", type: "text" },
        { name: "video_url", label: "Vídeo (URL)", type: "text" },
        { name: "featured", label: "Destaque", type: "boolean" },
        { name: "sort_order", label: "Ordem", type: "number" },
        {
          name: "status",
          label: "Status",
          type: "select",
          options: [
            { label: "Rascunho", value: "draft" },
            { label: "Publicado", value: "published" },
            { label: "Oculto", value: "hidden" },
          ],
        },
      ]}
      columns={[
        { key: "title", label: "Título" },
        { key: "status", label: "Status" },
        { key: "featured", label: "Destaque", render: (r) => (r["featured"] ? "Sim" : "Não") },
      ]}
    />
  );
}
